import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { MhsQuestions } from '../model/ui/mhs-questions';
import { EnvService } from 'src/app/env-service/env.service';

@Injectable({
  providedIn: 'root'
})
export class QuestionService {

    constructor(private http: HttpClient, private envService: EnvService) { }

    getMhsQuestions(state: string, policyNumber: number, carrier:string): Observable<MhsQuestions> {
      const url = environment.getApiUrl(environment.mhsQuestionsUrl(state,policyNumber,carrier),
                                        this.envService.mhsApiEndpoint,
                                        this.envService.apiSubscriptionId);
      return this.http.get<MhsQuestions>(url);
    }

}
